export default "__VITE_ASSET__C09n5eL4__"